module.exports = __webpack_public_path__ + "static/site_template-e76676643a04f017f5575113b02d3b85.svg";